import Typography from '@mui/material/Typography';

import { ensureDefined } from '@e-socna/utils';

import { formatQuantity } from '../../../utils/format-quantity.util';
import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import type { ServiceUsageCardCmp_ServiceUsage } from './fragments/service-usage.fragment';

interface Props {
  readonly serviceUsage: ServiceUsageCardCmp_ServiceUsage;
}

export const ServiceUsageInfos = ({ serviceUsage }: Readonly<Props>) => {
  const { unitsIdMap } = useReferencesContext();

  const { quantity } = ensureDefined({ quantity: serviceUsage.quantity });

  return (
    <>
      <Typography color="text.secondary" variant="overline">
        Informations Prestation
      </Typography>
      <Typography gutterBottom variant="body2">
        Quantité : {formatQuantity(quantity, unitsIdMap)}
      </Typography>
    </>
  );
};
